module.exports = __webpack_public_path__ + "static/media/zipadd.e0e6c007.svg";